import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.NetSuiteWorkflowDetails', {
    endStepBubbleTextNetSuite: 'Approve in Oracle NetSuite',
    endStepDescriptionApproveInNetSuite:
        'Approved {pluralTemplateName} will be automatically marked as "Approved" in Oracle NetSuite.',
});
